if ( ! customElements.get('modal-box') ) {

	// Storage can be blocked or hold junk; either way the modal counts as never shown.
	const storageGet = key => {
		try { return localStorage.getItem(key); } catch (e) { return null; }
	};
	const storageSet = (key, value) => {
		try { localStorage.setItem(key, value); } catch (e) {}
	};
	const readModalStorage = key => {
		try {
			const value = JSON.parse(storageGet(key));
			return value && typeof value === 'object' ? value : 'empty';
		} catch (e) {
			return 'empty';
		}
	};

	class ModalBox extends HTMLElement {

		constructor() {

			// The header script is the writer; this covers pages without it (the password page).
			window.inertElems = window.inertElems || document.querySelectorAll('[data-js-inert]');

			super();

			// AbortController so document-level listeners (mousemove, keydown)
			// are removed if/when this element leaves the DOM.
			this._abortController = new AbortController();

			this.o = {
				...{
					show: 10, 
					frequency: 'day', 
					enabled: true,
					showOnce: true,
					closeByKey: true,
					disableScroll: true,
					enableClose: false,
					type: false,
					blockTabNavigation: false,
					openedModalBodyClass: 'modal-opened',
				}, ...JSON.parse(this.dataset.options)
			};

			if ( this.o.type == "exit_intent_popup") {

				this.o.enabled = false;

				const showBanner = () => {
					this.o.enabled = true;
					
					this._modalKey = `modal-${document.location.hostname}-${this.id}`;
					this._modalStorage = readModalStorage(this._modalKey);
					if ( this.querySelector('[data-content]') ) {
						this._modalText = this.querySelector('[data-content]').textContent;
					}

					const timeNow = new Date().getTime();
					const inBetween = Math.round((timeNow - this._modalStorage['shown']) / 1000);

					let showModal = false;

					if ( this._modalStorage == 'empty'
						|| ( this.o.frequency == 'day' && inBetween > 86400 )
						|| ( this.o.frequency == 'week' && inBetween > 604800 )
						|| ( this.o.frequency == 'month' && inBetween > 2419200 )
						|| this._modalStorage['content'] != this._modalText
					) {
						showModal = true
					}

					if ( showModal ) {
						setTimeout(()=>{
							this.show();
						}, 0);
						setTimeout(()=>{
							this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));
						}, 100);
					}
				}

				let lastMouseY = 0; 
				let topOffset = 20; 

				document.addEventListener('mousemove', function(event) {
					const currentMouseY = event.clientY;
					if (currentMouseY < lastMouseY && currentMouseY < topOffset && ! Shopify.designMode) {
						showBanner();
					}
					lastMouseY = currentMouseY;
				}, { signal: this._abortController.signal, passive: true });
				
			}

			if ( this.o.type == "cookies") {
				this.o.enabled = false;

				const showBanner = () => {
					this.o.enabled = true;
					this.show();
				}
			
				const cookiesAccept = () => {
					window.Shopify.customerPrivacy.setTrackingConsent({
						"analytics": true,
						"marketing": true,
						"preferences": true
					}, () => {});
					storageSet('krown-cookie-banner', 'true');
				}
				const cookiesDecline = () => {
					window.Shopify.customerPrivacy.setTrackingConsent({
						"analytics": false,
						"marketing": false,
						"preferences": false
					}, () => {});
					storageSet('krown-cookie-banner', 'true');
				}
			
				const initCookieBanner = () => {
					if ( storageGet('krown-cookie-banner') !== 'true' ) {
						showBanner();
					}
				}

				this.querySelector('[data-js-cookies-accept]').addEventListener('click', cookiesAccept);
				this.querySelector('[data-js-cookies-decline]').addEventListener('click', cookiesDecline);

				window.Shopify.loadFeatures(
					[
						{
							name: 'consent-tracking-api',
							version: '0.1',
						},
					],
					error => {
						if (error) {
							throw error;
						}
						initCookieBanner();
					}
				);
			}

			if ( this.o.enabled ) {
			
				this._modalKey = `modal-${document.location.hostname}-${this.id}`;
				this._modalStorage = readModalStorage(this._modalKey);
				if ( this.querySelector('[data-content]') ) {
					this._modalText = this.querySelector('[data-content]').textContent;
				}

				const timeNow = new Date().getTime();
				const inBetween = Math.round((timeNow - this._modalStorage['shown']) / 1000);

				let showModal = false;

				if ( this._modalStorage == 'empty'
					|| ( this.o.frequency == 'day' && inBetween > 86400 )
					|| ( this.o.frequency == 'week' && inBetween > 604800 )
					|| ( this.o.frequency == 'month' && inBetween > 2419200 )
					|| this._modalStorage['content'] != this._modalText
				) {
					showModal = true
				}

				if ( showModal ) {
					setTimeout(()=>{
						this.show();
					}, parseInt(this.o.show*1000));
					setTimeout(()=>{
						this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));
					}, 100);
				}

			} else if ( this.o.enabled == false ) {
				this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));
			}
			
			if ( this.o.enableClose == true ) {
				this.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{this.hide(this.o.showOnce)}));
			}

			if ( this.o.closeByKey ) {
				document.addEventListener('keydown', e=>{
					// An open list inside the modal (a form's country picker) closes on Esc first and marks it handled.
					if ( e.keyCode === 27 && ! e.defaultPrevented ) {
						if ( this.classList.contains('active') ) {
							this.hide(this.o.showOnce);
						}
					}
				}, { signal: this._abortController.signal });
			}

		}

		disconnectedCallback() {
			// Aborts every document-level listener registered with this signal
			// (mousemove for exit-intent, keydown for ESC).
			this._abortController?.abort();
			// Removed while open (an editor re-render): the page gets its scrolling and inert parts back.
			clearTimeout(this._showTimer);
			clearTimeout(this._focusTimer);
			clearTimeout(this._hideTimer);
			this._unlockScroll();
			this._releaseInert();
		}

		// The shared lock keeps the scroll position; before utils.js has loaded (or on the password layout) only the class is set.
		_lockScroll(){
			if ( this._scrollLock ) return;
			this._scrollLock = window.OrdoUtils ? 'shared' : 'class';
			if ( this._scrollLock == 'shared' ) {
				OrdoUtils.lockScroll(this.o.openedModalBodyClass);
			} else {
				document.body.classList.add(this.o.openedModalBodyClass);
			}
		}

		_unlockScroll(){
			if ( this._scrollLock == 'shared' ) {
				OrdoUtils.unlockScroll(this.o.openedModalBodyClass);
			} else if ( this._scrollLock == 'class' ) {
				document.body.classList.remove(this.o.openedModalBodyClass);
			}
			this._scrollLock = null;
		}

		show(){
			// A show straight after a hide (an editor reselect) cancels the hide, so it can't set display: none later.
			clearTimeout(this._hideTimer);
			clearTimeout(this._showTimer);
			clearTimeout(this._focusTimer);
			this.setAttribute('style', '');
			this._showTimer = setTimeout(()=>{
				this.classList.add('active');
				if ( this.o.disableScroll ) {
					this._lockScroll();
				}
				// Inert goes only on the parts of the page that don't have it yet, so closing leaves an open drawer's inert in place.
				if ( this.o.blockTabNavigation && ! this._inerted ) {
					this._inerted = [...window.inertElems].filter(elm=>! elm.hasAttribute('inert'));
					this._inerted.forEach(elm=>{
						elm.setAttribute('inert', '');
					});
				}
			}, 10);
			this._focusTimer = setTimeout(()=>{
				const firstFocus = this.querySelector('[data-js-first-focus]');
				if ( firstFocus ) {
					if ( ! this._returnFocus && ! this.contains(document.activeElement) ) {
						this._returnFocus = document.activeElement;
					}
					firstFocus.focus();
				}
			}, 250);
		}

		hide(remember=false){
			clearTimeout(this._showTimer);
			clearTimeout(this._focusTimer);
			this.classList.remove('active');
			this._unlockScroll();
			clearTimeout(this._hideTimer);
			this._hideTimer = setTimeout(()=>{
				this.style.display = 'none';
			}, 500);
			if ( remember && this._modalKey && ! Shopify.designMode ){
				storageSet(this._modalKey, JSON.stringify({
					'shown': (new Date().getTime()),
					'content': this._modalText
				}));
			}
			this._releaseInert();

			// Focus goes back to where it was before the modal took it, once inert is gone, unless it has moved on since.
			const returnFocus = this._returnFocus;
			this._returnFocus = null;
			const active = document.activeElement;
			if ( returnFocus?.isConnected && ( ! active || active === document.body || this.contains(active) ) ) {
				returnFocus.focus({ preventScroll: true });
			}
		}

		_releaseInert(){
			this._inerted?.forEach(elm=>{
				elm.removeAttribute('inert');
			});
			this._inerted = null;
		}

	}

  if ( typeof customElements.get('modal-box') == 'undefined' ) {

		// Clone modal elements and move to end of body IF append-top-body
		
		const originalElements = document.querySelectorAll('modal-box');

		originalElements.forEach((originalElement) => {
			const dataOptions = JSON.parse(originalElement.dataset.options);
			if ( dataOptions.appendToBody === true ) {
				document.body.appendChild(originalElement);
			}
		});

		customElements.define('modal-box', ModalBox);

	}

	// Shopify events

	document.addEventListener('shopify:section:select', (e)=>{
		if ( e.target.classList.contains('mount-popup') ) {
			e.target.querySelector('modal-box').style.display = 'block';
			e.target.querySelector('modal-box').show();
		}
	});
	document.addEventListener('shopify:block:select', (e)=>{
		if ( e.target.hasAttribute('data-modal-box') ) {
			e.target.style.display = 'block';
			e.target.show();
		}
	});
	document.addEventListener('shopify:block:deselect', (e)=>{
		if ( e.target.hasAttribute('data-modal-box') ) {
			e.target.hide();
		}
	});
	document.addEventListener('shopify:section:deselect', (e)=>{
		if ( e.target.classList.contains('mount-popup') ) {
			e.target.querySelector('modal-box').hide();
		}
	});

}